import { ReferralReward } from '@recruitee/http/types';
import { createEntityCollectionStore, pipeState } from '@recruitee/ngrx';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<ReferralReward>()(
  EntityStoreKey.rewards,
  {
    customActions: adapter => ({
      fetchOneSuccess: (state, { data, scope }: { data: ReferralReward; scope?: any }) =>
        pipeState(
          state,
          next =>
            adapter.markAsLoaded(next, {
              entities: [],
              scope: scope || 'main',
            }),
          next =>
            adapter.addOne(next, data, {
              scope: scope || 'main',
            }),
        ),
    }),
  },
);

export {
  actions as RewardsActions,
  reducer as rewardsReducer,
  selectors as rewardsSelectors,
  namespace as RewardsNamespace,
};
